import React from "react";
import Layout from "../components/ui/Layout";
import Container from "../components/ui/Container";
import LogoById from "../components/ui/LogoById";
import classNames from "classnames";

const jobsData = [
  {
    logo: { id: "harness" },
    title: "Senior/Staff SDET-platform",
    description:
      "Looking for Senior SDET who owns, enjoys & contributes towards the quality of the whole product, covering functional, automation, performance, scalability, and usability testing & beyond ",
    link: "https://jobs.lever.co/harness/b175fc7b-c614-4426-9358-67c2e17a6e72",
  },
  {
    logo: { id: "turing" },
    title: "Senior Software Developer  - Remote",
    description:
      "Job responsibilites include Design new software programs, websites, and applications, Write advanced code and review updated software systems, Collaborate with different project stakeholders to deliver innovative software solutions, Perform intensive testing of all new and existing programs, Stay up to date with the latest technological trends, Work with a diverse team to automate various processes & build the required software, Develop solutions to improve the performance and scalability of systems",
    link: "http://turing.com/s/WBqcjN",
  },
  {
    logo: { id: "geekyants" },
    title: "Software Engineer - JS Developer & Senior React Developer",
    description:
      "GeekyAnts is a design and development studio that specializes in building solutions for web and mobile that drive innovation and transform industries and lives. We're always on the hunt for like-minded geniuses who love to question the norms and push the boundaries with experiments. If you are one of those then come, join us.",

    link: "https://geekyants.com/join-geekyants/",
  },
];

function ApplyButton({ href, children, className }) {
  const className1 = classNames(
    className,
    "ns-primary-button",
    "bg-blue rounded-full",
    "text-white",
    "text-lg md:text-xl",
    "cursor-pointer outline-none focus:outline-none",
    "py-3 md:py-4 px-6 md:px-8"
  );
  return (
    <div>
      <a href={href} className={className1}>
        {children}
      </a>
    </div>
  );
}

function Job({ logo, title, description, link }) {
  return (
    <div className="block md:grid grid-cols-4 mb-20">
      <div className="mb-4 mr-10">
        <LogoById id={logo.id} />
      </div>
      <div className="col-span-3">
        <h2 className="font-bold mb-4 text-xl md:text-2xl">{title}</h2>
        <p className="mb-8 text-lg md:text-xl">{description}</p>
        <ApplyButton className="" href={link}>
          Apply
        </ApplyButton>
      </div>
    </div>
  );
}

const Jobs = () => (
  <Layout>
    <Container
      id="proposals"
      className="py-2 md:py-10 px-2 md:px-48"
      backgroundClassName="bg-white"
    >
      <div className="mb-10 text-center">
        <h2 className="uppercase font-bold text-4xl md:text-5xl mt-4">
          Job Board
        </h2>
        <p className="text-lg md:text-xl">
          Job opportunities in our sponsor companies
        </p>
      </div>
      <div>
        {jobsData.map((jobData, index) => (
          <Job key={index} {...jobData} />
        ))}
      </div>
    </Container>
  </Layout>
);

export default Jobs;

// const jobsData = [
//   {
//     logo: {
//       id: "archimydes",
//     },
//     title: "Full Stack Engineer",
//     description:
//       "Archimydes is a Software Development Guild. The Guild is focused on enabling developers to Engage, Grow & Earn. We aim to decouple income from geography, nurture excellence, and foster belonging. Come join us and help us re-imagine work.",
//     link: "https://www.notion.so/Archimydes-Job-Board-b39e9b91ef3d46b0bb5c2d56d3052567",
//   },
//   {
//     logo: { id: "atlantis" },
//     title: `SOFTWARE ENGINEER(Applications)`,
//     description: `
//     Do you love building simple but amazing products that help people live a better financial life?
//     We’re looking for outstanding engineers who can build end to end applications in Python and React / React
//     Native.
//     `,
//     link: `https://www.notion.so/Jobs-Atlantis-f1ac89129f1947cbb093ac2336d7a7a5`,
//   },
//   {
//     logo: { id: "groww" },
//     title: "Software Engineer",
//     description:
//       "At Groww, we are changing the way india invests. Come join us and be a part of this exciting journey. We’re taking complicated stuff and making it super simple. Our teams are full of smart and savvy folks working on challenging tasks. We use React and React Native for our front end tech stack.",
//     link: "https://groww.in/about-us",
//   },
//   {
//     logo: { id: "geekyants" },
//     title: "Front-end Engineer",
//     description:
//       " Do you want to be a part of a team that builds the next influential app in the social and e-commerce space? Hop on, we at GeekyAnts are passionate about the technologies of today and tomorrow that include React, React Native, Flutter & Svelte.",
//     link: "https://geekyants.com/current-openings/software-engineer",
//   },
//   {
//     logo: { id: "harness" },
//     title: "Software Engineer / Senior software Engineer - Frontend",
//     description:
//       "At Harness, we believe in a UX-first engineering approach across the organization. In this role, you will be responsible for writing clean, killer code to create fantastic and user-friendly experiences. You will be involved in all aspects of product design and user experience and will lead turning wireframes into polished and beautiful user interfaces.",
//     link: "https://jobs.lever.co/harness?location=Bangalore&commitment=Full-Time&department=R%26D&team=Engineering%20-%20Dev%20%26%20QA",
//   },
//   // {
//   //   logo: { id: "hotstar" },
//   //   title: "Software Development Engineer - Web",
//   //   description:
//   //     "We are striving to create the best Video content destination for our consumers on a varied set of devices, from phones to tablets, including devices coming out with bleeding edge of technology. Our web application team is heavily focused on delivering an unmatchable user experience on these devices while our consumers watch the content they love! The pace of our growth is incredible – if you want to tackle hard and interesting problems at scale, and create an impact within an entrepreneurial environment, join us!",
//   //   link: "https://jobs.lever.co/hotstar/a6f43825-177e-4f23-936f-83196f8552dc",
//   // },
//   // {
//   //   logo: <Hasura className="w-32" />,
//   //   title: "React/Typescript Engineer",
//   //   description:
//   //     "Hasura is an opensource product working on making data access easy using GraphQL & serverless technologies. Our console, which is a product used & loved by tens of thousands of developers globally is a React codebase, which is soon going to be moving to TypeScript. We're looking for react/typescript engineers of all experience levels to join our team to help in building software that powers applications in some of the most exciting companies globally.",
//   //   link: "https://hasura.io/careers/frontend-react-developer",
//   // },
//   // {
//   //   logo: <Xactly className="w-32" />,
//   //   title: "Senior Software Engineer - UI",
//   //   description:
//   //     "Xactly is looking for a stellar individual to develop user interface of new and existing products. You will work with extremely talented engineering team to design , implement and deploy UI layer of products. You’ll bring to the role a passion for building intuitive user-interfaces in conjunction with UX designers that users find both natural and engaging. The ideal candidate will be proficient and proven in the design and implementation of modern web application architectures. You must be strong in all aspects of the presentation layer and the technologies such as Node.js, React, Angular and Ajax. We have total 8 openings for UI Engineers",
//   //   link:
//   //     "https://recruit.hirebridge.com/v3/Jobs/JobDetails.aspx?cid=7801&jid=513879&locvalue=1020",
//   // },

//   // {
//   //   logo: <Cleartax className="w-32" />,
//   //   title: "FrontEnd Engineer",
//   //   description:
//   //     "Would you like to be in a team that uses cutting-edge web technologies including React, GraphQL & TypeScript while ensuring security and great user experience with a mission of simplifying financial lives in India, this is the place to be. We believe in extreme customer obsession, passion for going deep and committing to great technology which defines our engineering team.",
//   //   link:
//   //     "https://www.instahyre.com/job-51080-software-engineer-ii-at-cleartax-bangalore",
//   // },
//   {
//     logo: { id: "goibibo" },
//     title: "Frontend Engineer",
//     description:
//       "Become a Tripper !! Join our team of tech-first thinkers, creative problem solvers, passionate customer advocates and relentless executors.",
//     link: "https://careers.makemytrip.com/opportunity/18841/react-js",
//   },
//   {
//     logo: { id: "openhouse" },
//     title: "Senior Frontend Engineer and Lead Mobile Engineer",
//     description:
//       "The world is learning to learn online, but simply delivering content just doesn’t feel natural, warm or relatable. At Openhouse, we are building a platform that pushes the boundaries of edtech to a new era of highly active, social & community-driven learning. We are looking for senior React/React Native engineers that are eager to learn, and build a meaningful company. You will have the unique opportunity to create products that will change online learning and shape the culture of our engineering organization.",
//     link: "https://ohstudy.live/careers",
//   },
//   {
//     logo: { id: "quolum" },
//     title: "Frontend Engineer",
//     description:
//       "Join us to tackle a billion dollars in SaaS Spend. This is a ground-level opportunity to render multi-dimensional data in an enterprise product. We are a team of 12 based out of San Francisco and Bangalore.",
//     link: "https://www.linkedin.com/jobs/view/2348439679/?refId=vNpM20qZkuPf%2BHGthdK%2FOw%3D%3D&trackingId=2WiqkExu6xRXVBe9jA9SWg%3D%3D",
//   },
//   {
//     logo: { id: "razorpay" },
//     title: "Senior Frontend Engineer (React/React Native)",
//     description:
//       "Are you Looking for amazing work, culture and an equally amazing interview experience? The team at Razorpay strives to build solid frontend foundations, infrastructure and top-notch experiences.",
//     link: "https://razorpay.com/jobs-frontend/",
//   },
// ].reverse();
